import React, { useState } from 'react'
import logo_pure_2_200 from '../img/logo_pure_b_200.jpg'
import { HiOutlineMail, HiOutlineViewGrid, HiOutlineLibrary, HiOutlineHome, HiOutlineCreditCard, HiOutlineClipboardList, HiOutlineUserGroup, HiOutlineUserAdd } from "react-icons/hi";
import './navbar.css'
import { useLocation } from 'react-router-dom'
import { NavHashLink as Link } from 'react-router-hash-link'

const Navbar = () => {

	const [isOpen, setIsOpen] = useState(false)
	const buttonClasses = 'flex items-center justify-center w-full text-right md:text-center px-2 py-2 uppercase'
	const iconClasses = 'size-4 me-1 '
	const liClasses = 'flex min-w-fit items-center justify-center hover:bg-amber-500 px-2'

	const menuItems = [
		{ id: 1, name: 'Úvod',	to: '#csss', icon: <HiOutlineHome className={iconClasses}/>},
		{ id: 2, name: 'O nás', to: '#about', icon: <HiOutlineLibrary className={iconClasses}/>},
		{ id: 3, name: 'Poslání a služby', to: '#services', icon: <HiOutlineViewGrid className={iconClasses}/>},
		{ id: 4, name: 'Ceník', to: '#priceList', icon: <HiOutlineCreditCard className={iconClasses}/>},
		{ id: 5, name: 'Naše zásady', to: '#principles', icon: <HiOutlineClipboardList className={iconClasses}/>},
		// { id: 5, name: 'Pracovní pozice', to: '#jobs', icon: <HiOutlineUserAdd className={iconClasses}/>},
		{ id: 6, name: 'Aktuality', to: '#news', icon: <HiOutlineUserGroup className={iconClasses}/>},
		{ id: 7, name: 'Kontakty', to: '#contacts', icon: <HiOutlineMail className={iconClasses}/>},
	]
		
	const CustomNavHashLink = ({ to, children }) => {
		const location = useLocation();
		const selected = location.hash === to;
		const scroll=(el) => {
			const yOffset = -75;
			const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
			window.scrollTo({ top: y, behavior: 'smooth' });
		}

		return (
			<Link
				to={to}
				scroll={scroll}
				className={`${buttonClasses} ${selected ? 'selected' : ''}`}
				onClick={()=>{setIsOpen(!isOpen)}}
			>
				{children}
			</Link>
		)
	}

	const navlinks = (
		<>	
			<ul className='flex flex-col h-full md:flex-row'>
				{
					menuItems.map(oneItem => (

						<li className={liClasses} key={oneItem.name}>
							<CustomNavHashLink to={oneItem.to}> {oneItem.name}</CustomNavHashLink> 
						</li>	
					))
				}
			</ul>
		</>
	)
	
	const menuStats = {
		closed: (<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 50 50">
					<path d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 L 0 7.5 z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 L 0 22.5 z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 L 0 37.5 z"></path>
				</svg>
		),
		open: (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-8">
				<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
		 		</svg>
		)
	}

  return (
	<nav className='container mx-auto'>
	  <div className='w-full px-4 sm:px-6 lg:px-8'>
		<div className='flex items-center justify-between h-[75px]'>
			<div className='flex w-full h-full justify-between'>
				<div className="flex items-center">
					<div className="">
						<img src={logo_pure_2_200} className='h-[30px] md:h-[50px]' alt="CSS Sokolov Logo" />
					</div>
					<div className='text-2xl ps-2'></div>
				</div>
				
				<div className='hidden md:flex'>
					{navlinks}
				</div>
			</div>
			<div className='md:hidden'>
				<button className='' onClick={()=>{setIsOpen(!isOpen)}} type='button'>
					{
						isOpen ? (menuStats.open) : (menuStats.closed)
					}
				</button>
			</div>
		</div>
	  </div>
	  {
		isOpen && (
			<div className="fixed md:hidden right-0 z-50 bg-white rounded-bl-lg shadow-lg ms-0 px-0 py-2">
				{navlinks}
			</div>
		)
	  }
	</nav>
  )
}

export default Navbar
